module.exports = require('./sso')


//////////////////
// WEBPACK FOOTER
// ./~/mam-sso/index.js
// module id = 1586
// module chunks = 0